
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PageHeader, PageHeaderImage } from 'components/Page';
import SegmentList from 'components/Lists/SegmentList';
import { Link } from 'react-router-dom'
import { mediagroups } from 'data/actions';

class BrandHeader extends Component {
  
    
    static contextTypes = {
      router: PropTypes.object
    };
  
    componentWillMount() {
      this.props.actions.fetchMediagroups();
    }

    handleLogoClick = (e) => {
      this.context.router.history.push("/media/" + this.props.brand.key);
    }
    
    title = () => <span className="brand_header__path">
      {this.props.brand ? <Link className="link" to={`/media/${this.props.brand.key}`}>{this.props.brand.name}</Link> : null }
      {this.props.category ? <Link className="link" to={`/media/${this.props.brand.key}/${this.props.category.key}`}>{this.props.category.name}</Link> : null }
      {this.props.product ? <Link className="link" to={`/media/${this.props.brand.key}/${this.props.category.key}/${this.props.product.key}`}>{this.props.product.name}</Link> : null }
    </span>
//
    render = () => {
      var mg = this.props.brand.mediagroupid ? this.props.mediagroups[this.props.brand.mediagroupid]: {};
      
      return[ 
        <PageHeaderImage key="image" url={this.props.brand.bgimageUrl}/>,
        <PageHeader key="header"  {...this.props} onLogoClick={this.handleLogoClick}  title={this.title()} bg={this.props.brand.bgimageUrl}  logo={this.props.brand.logoUrl} mediagrouplogo={mg}>
          {this.props.children}
        </PageHeader>
        ]
    }
  }

function mapStateToProps(state, ownProps) {
  return {
    mediagroups: state.mediagroups.list.data,
  };
}
  
const mapDispatch = (dispatch) => {
  return {
      actions: bindActionCreators({...mediagroups}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatch)(BrandHeader)





// WEBPACK FOOTER //
// ./src/components/Brand/BrandHeader.jsx